import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/advisories')({
  component: AdvisoriesLayout,
});

function AdvisoriesLayout() {
  return <Outlet />;
}
